import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreConstants } from 'src/app/shared/models/store.model';
import * as LogMessagesReducer from './reducer';
import { LogMessageState } from './reducer';

export const getLogMessageState = createFeatureSelector<LogMessageState>(StoreConstants.FEATURE_LOG_MESSAGES);

export const getPageResult = createSelector(getLogMessageState, LogMessagesReducer.pageResult);

export const getPageLoading = createSelector(getLogMessageState, LogMessagesReducer.pageLoading);
